<script>
export default {
  name: 'NavigatorOnline',
  data () {
    return {
      online: null
    }
  },
  watch: {
    online () {
      this.$emit('change', {
        online: this.online
      })
    }
  },
  render () {
    return null
  },
  mounted () {
    addEventListener('online', () => {
      this.online = true
    })
    addEventListener('offline', () => {
      this.online = false
    })
    this.online = navigator.onLine
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/navigator-online/navigator-online.vue